
export interface IResumeLicenseSimulationRequest {
   
    LicenseKey: string;
    Initials: string;
}

export class ResumeLicenseSimulationRequest implements IResumeLicenseSimulationRequest {
    LicenseKey: string;
    Initials: string;
}

